import React, { useEffect, useState } from 'react';
import moment from 'moment';

import FormContainer from '../../../components/FormContainer';
import InputInfo from '../../../components/Inputs/Info';
import Accordion from '../../../components/Accordion';
import Divider from '../../../components/Divider';
import ShortageField from './ShortageField';

import { addMaskCpf } from '../../../utils';

import * as S from './styles';

function Dados({ dados }) {
    const [situacaoBeneficiarioDap, setSituacaoBeneficiarioDap] = useState('');

    useEffect(() => {
        if (dados.situacaoBeneficiario === 'APOSENTANDO' || dados.situacaoBeneficiario === 'DEMITIDO') {
            setSituacaoBeneficiarioDap('Sim');
        } else {
            setSituacaoBeneficiarioDap('Não');
        }
    }, [dados]);

    const defaultProps = {
        required: true,
    };

    return (
        <>
            <S.ContentData>
                <Accordion title="Dados de titular" hasCollapse={false}>
                    <FormContainer>
                        <InputInfo
                            field={{ ...defaultProps, label: 'N° da carteirinha', value: dados.numCarteirinhaTitular }}
                        />
                        <InputInfo
                            field={{ ...defaultProps, label: 'Nome completo', value: dados.nomeCompletoTitular }}
                        />
                        <InputInfo field={{ ...defaultProps, label: 'Contrato', value: dados.contrato.nome }} />
                        <InputInfo field={{ ...defaultProps, label: 'Empresa', value: dados.empresa }} />
                        <InputInfo
                            field={{
                                ...defaultProps,
                                label: 'DAP',
                                value: situacaoBeneficiarioDap,
                            }}
                        />
                        <InputInfo field={{ ...defaultProps, label: 'Categoria', value: dados.situacaoBeneficiario }} />
                        <InputInfo
                            field={{
                                ...defaultProps,
                                label: 'Data do desligamento',
                                value: dados.planoSaude.dataExclusao
                                    ? moment(dados.planoSaude.dataExclusao, 'DD/MM/YYYY').format('DD/MM/YYYY')
                                    : '',
                            }}
                        />
                    </FormContainer>
                </Accordion>
            </S.ContentData>

            <S.ContentData>
                <Accordion title={`Dados de ${dados.tipo.toLowerCase()}`} hasCollapse={false}>
                    <FormContainer>
                        <InputInfo field={{ ...defaultProps, label: 'Plano de saúde', value: dados.planoSaude.nome }} />
                        <InputInfo
                            field={{
                                ...defaultProps,
                                label: 'Data de início do plano',
                                type: 'date',
                                value: '',
                            }}
                        />
                        <InputInfo
                            field={{ ...defaultProps, label: 'N° de carteirinha', value: dados.numCarteirinha }}
                        />
                        <InputInfo
                            field={{
                                label: 'Carência do plano',
                                value: <ShortageField shortages={dados.planoSaude.carencias} />,
                            }}
                        />
                    </FormContainer>

                    <Divider />

                    <FormContainer>
                        <InputInfo field={{ ...defaultProps, label: 'CPF', value: addMaskCpf(dados.cpf) }} />
                        <InputInfo field={{ ...defaultProps, label: 'Nacionalidade', value: dados.nacionalidade }} />
                        <InputInfo field={{ ...defaultProps, label: 'Nome completo', value: dados.nomeCompleto }} />
                        <InputInfo field={{ ...defaultProps, label: 'Nome social', value: dados.nomeSocial }} />
                        <InputInfo
                            field={{
                                ...defaultProps,
                                label: 'Data de nascimento',
                                value: dados.dataNascimento,
                                type: 'date',
                            }}
                        />
                        <InputInfo field={{ ...defaultProps, label: 'Sexo', value: dados.sexo }} />
                        <InputInfo field={{ ...defaultProps, label: 'Nome da mãe', value: dados.nomeMae }} />
                        <InputInfo field={{ ...defaultProps, label: 'Estado civil', value: dados.estadoCivil }} />
                        <InputInfo
                            field={{ ...defaultProps, label: 'Grau de parentesco', value: dados.grauParentesco }}
                        />
                        <InputInfo
                            field={{
                                label: 'Data do casamento/união estável',
                                value: dados.dataCasamento,
                                type: 'date',
                            }}
                        />
                        <InputInfo field={{ ...defaultProps, label: 'Nº do PIS', value: dados.numPis }} />
                        <InputInfo field={{ ...defaultProps, label: 'Nº Cartão do SUS', value: dados.numCartaoSus }} />
                    </FormContainer>
                </Accordion>
            </S.ContentData>
        </>
    );
}

export default Dados;
